export default __webpack_public_path__ + "static/media/img3.fe51486d.jpeg";